import {
  GET_RESE_COMMAND_DIVISION_DETAILS,
  RESE_POST_CREATE_JOB,
  RESE_GET_JOB_DETAILS,
  RESET_RESE_CREATE_JOB_SUCCESS_MESSAGE,
  RESET_RESE_MODIFY_JOB_DETAILS,
  GET_RESE_SERVER_DETAILS_BY_JOB_ID,
  CANCEL_RESE_GRAFANA_AGENT_REMOTE_COMMAND_SCHEDULE,
  SET_RESE_MODIFY_JOB_DETAILS,
  SET_RESE_CLONE_JOB_DETAILS,
  RESET_RESE_CLONE_JOB_DETAILS,

} from "./actionTypes";

export const getRESECommandDivisionDetailsInit = () => ({
  type: GET_RESE_COMMAND_DIVISION_DETAILS.INIT,
});

export const getRESECommandDivisionDetailsSuccess = (divisionDetail) => ({
  type: GET_RESE_COMMAND_DIVISION_DETAILS.SUCCESS,
  payload: divisionDetail,
});

export const getRESECommandDivisionDetailsFailure = (errorMessage) => ({
  type: GET_RESE_COMMAND_DIVISION_DETAILS.ERROR,
  payload: errorMessage,
});

export const resepostCreateJobInit = (payload) => ({
  type: RESE_POST_CREATE_JOB.INIT,
  payload,
});

export const resepostCreateJobSuccess = (createJob) => ({
  type: RESE_POST_CREATE_JOB.SUCCESS,
  payload: createJob,
});

export const resepostCreateJobFailure = (errorMessage) => ({
  type: RESE_POST_CREATE_JOB.ERROR,
  payload: errorMessage,
});

export const getRESEJobDetailsInit = (startDate, endDate, offset) => ({
  type: RESE_GET_JOB_DETAILS.INIT,
  startDate,
  endDate,
  offset,
});

export const getRESEJobDetailsSuccess = (jobDetails) => ({
  type: RESE_GET_JOB_DETAILS.SUCCESS,
  payload: jobDetails,
});

export const getRESEJobDetailsFailure = (errorMessage) => ({
  type: RESE_GET_JOB_DETAILS.ERROR,
  payload: errorMessage,
});

export const resetCreateJobSuccessMessage = () => ({
  type: RESET_RESE_CREATE_JOB_SUCCESS_MESSAGE,
});

export const resetRESEModifyJobDetails = () => ({
  type: RESET_RESE_MODIFY_JOB_DETAILS,
});

export const getRESEServerDetailsByJobIdInit = (jobId) => ({
  type: GET_RESE_SERVER_DETAILS_BY_JOB_ID.INIT,
  jobId,
});

export const getRESEServerDetailsByJobIdSuccess = (serverDetails) => ({
  type: GET_RESE_SERVER_DETAILS_BY_JOB_ID.SUCCESS,
  payload: serverDetails,
});

export const getRESEServerDetailsByJobIdFailure = (errorMessage) => ({
  type: GET_RESE_SERVER_DETAILS_BY_JOB_ID.ERROR,
  payload: errorMessage,
});





export const cancelRESECommandScheduleInit = (
  cancelSchedule,
  startDate,
  endDate,
  offset
) => ({
  type: CANCEL_RESE_GRAFANA_AGENT_REMOTE_COMMAND_SCHEDULE.INIT,
  cancelSchedule,
  startDate,
  endDate,
  offset,
});

export const cancelRESECommandScheduleSuccess = (response) => ({
  type: CANCEL_RESE_GRAFANA_AGENT_REMOTE_COMMAND_SCHEDULE.SUCCESS,
  payload: response,
});

export const cancelRESECommandScheduleFailure = (
  errorMessage
) => ({
  type: CANCEL_RESE_GRAFANA_AGENT_REMOTE_COMMAND_SCHEDULE.ERROR,
  payload: errorMessage,
});




export const setRESEModifyJobDetails = (resemodifyJobDetails) => ({
  type: SET_RESE_MODIFY_JOB_DETAILS,
  payload: resemodifyJobDetails,
});

export const setCloneJobDetails = (resecloneJobDetails) => ({
  type: SET_RESE_CLONE_JOB_DETAILS,
  payload: resecloneJobDetails,
});

export const resetCloneJobDetails = () => ({
  type: RESET_RESE_CLONE_JOB_DETAILS,
});
